export const validateRFCOrCURP = (input) => {
    // Regular expression for RFC validation
    // [A-ZÑ&]{3,4}    : three or four letters, including Ñ or &
    // \d{6}           : six digits representing a date in YYMMDD format
    // [A-Z\d]{3} : three letters or digits
    const rfcPattern = /^[A-ZÑ&]{3,4}\d{6}[A-Z\d]{3}$/;
    // Regular expression for CURP validation
    // [A-Z]         : first character is a letter between A and Z
    // [AEIOUX]      : second character is one of the specified vowels or 'X'
    // [A-Z]{2}      : next two characters are letters between A and Z
    // [0-9]{6}      : six digits representing the birth date in YYMMDD format
    // [HMX]          : gender character, either 'H',  'M', or 'X'
    // [A-Z]{2}      : two letters representing the state code
    // [B-DF-HJ-NP-TV-Z]{3} : three consonants (excluding vowels and certain letters)
    // [A-Z\d]       : one letter or digit
    // \d            : one digit
    const curpPattern = /^[A-Z][AEIOUX][A-Z]{2}[0-9]{6}[HMX][A-Z]{2}[B-DF-HJ-NP-TV-Z]{3}[A-Z\d]\d$/;
    return rfcPattern.test(input) || curpPattern.test(input);
};
